import { render, staticRenderFns } from "./VehiculoPropietario.vue?vue&type=template&id=4567e1dd&scoped=true"
import script from "./VehiculoPropietario.vue?vue&type=script&lang=js"
export * from "./VehiculoPropietario.vue?vue&type=script&lang=js"
import style0 from "./VehiculoPropietario.vue?vue&type=style&index=0&id=4567e1dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4567e1dd",
  null
  
)

export default component.exports